// extracted by mini-css-extract-plugin
module.exports = {"close":"modalMenu_close__3S1bI","closeLine":"modalMenu_closeLine__39YMs"};